import { CircularProgress } from '@mui/material';

export const ButtonCircularProgress = () => {
	return (
		<CircularProgress
			size={20}
			sx={{
				position: 'absolute',
				right: 'calc(50% - 10px)',
				top: '2px',
				width: '100%',
			}}
		/>
	);
};
